import {
  WORK_IMPORTED_UPDATE, WORKS_IMPORT_ERROR, WORKS_IMPORT_LOADING,
  WORKS_IMPORT_UPDATE
} from "../actions/workImportActions";

const INITIAL_STATE = {
  worksImport: [],
  worksImportLoading: false,
  worksImportError: null,
  workImported: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case WORKS_IMPORT_UPDATE:
      return {
        ...state,
        worksImport: action.payload.data,
        worksImportPagination: action.payload.pagination,
        worksImportError: action.payload.message,
      };
    case WORKS_IMPORT_ERROR:
      return { ...state, worksImportError: action.payload };
    case WORKS_IMPORT_LOADING:
      return {...state, worksImportLoading: action.payload };
    case WORK_IMPORTED_UPDATE:
      return {...state, workImported: action.payload };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/works/reducers/WorksImportReducer.js